/*
  Wishlist cho theme Tinker - them 14/09/2026, chep tu judeshaworks.com.

  Tinker khong co san wishlist (khac Kalles co custom element hdt-wishlist), nen dung
  o day mot custom element toi gian, khong phu thuoc thu vien nao:

  - Luu danh sach id san pham vao localStorage key "crossoraworks:wishlist"
  - Moi nut la <wishlist-toggle product-id="..."> boc mot <button>
  - Trang thai duoc doc lai khi tai trang, va dong bo giua cac tab qua su kien "storage"
  - So luong duoc phat ra qua CustomEvent "wishlist:change" de cho nao muon hien so dem
    thi tu lang nghe, khong rang buoc vao header

  Luu y: day la wishlist phia trinh duyet, moi thiet bi mot danh sach rieng.
  Muon dong bo theo tai khoan khach hang thi phai dung app hoac metafield.
*/
(() => {
  const KEY = 'crossoraworks:wishlist';

  const doc = () => {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch (e) {
      return [];
    }
  };

  const ghi = (arr) => {
    try {
      localStorage.setItem(KEY, JSON.stringify([...new Set(arr.map(String))]));
    } catch (e) {
      /* che do rieng tu hoac bo nho day - bo qua, nut van bam duoc trong phien */
    }
    phatSuKien();
  };

  const phatSuKien = () => {
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { items: doc(), count: doc().length } })
    );
  };

  class WishlistToggle extends HTMLElement {
    connectedCallback() {
      this.id_sp = this.getAttribute('product-id');
      this.nut = this.querySelector('button');
      if (!this.nut || !this.id_sp) return;

      this.veLai();
      this.nut.addEventListener('click', this.bam);
      document.addEventListener('wishlist:change', this.veLai);
      window.addEventListener('storage', this.dongBoTab);
    }

    disconnectedCallback() {
      this.nut?.removeEventListener('click', this.bam);
      document.removeEventListener('wishlist:change', this.veLai);
      window.removeEventListener('storage', this.dongBoTab);
    }

    dongBoTab = (e) => {
      if (e.key === KEY) this.veLai();
    };

    daCo() {
      return doc().includes(String(this.id_sp));
    }

    veLai = () => {
      const co = this.daCo();
      this.toggleAttribute('data-in-wishlist', co);
      this.nut.setAttribute('aria-pressed', co ? 'true' : 'false');
      const nhan = co ? this.dataset.labelRemove : this.dataset.labelAdd;
      if (nhan) {
        this.nut.setAttribute('aria-label', nhan);
        this.nut.setAttribute('title', nhan);
      }
    };

    bam = (e) => {
      // nut nam de tren the <a> phu kin card nen phai chan lan truyen,
      // khong thi bam vao tim se dieu huong sang trang san pham
      e.preventDefault();
      e.stopPropagation();
      const ds = doc();
      const id = String(this.id_sp);
      ghi(ds.includes(id) ? ds.filter((x) => x !== id) : [...ds, id]);
      this.veLai();
    };
  }

  if (!customElements.get('wishlist-toggle')) {
    customElements.define('wishlist-toggle', WishlistToggle);
  }

  // phat mot lan luc tai trang de cho nao dem so co gia tri ban dau
  document.addEventListener('DOMContentLoaded', phatSuKien);
})();
